import React from "react";
import Bola from "../Bola";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

import Video from "./Video";

export default function VideoList() {
  return (
    <div>
      <Navbar />
      <Bola />
      <Video />
      <Footer />
    </div>
  );
}
